var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',{attrs:{"id":"header"}},[_c('div',{attrs:{"id":"navbar"}},[_c('Navbar')],1)]),_c('main',{attrs:{"id":"main"}},[_c('notifications',{attrs:{"position":"bottom right"}}),_c('router-view')],1),_c('footer',[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }